import { Spinner } from "../ui";

export const FullScreenLoader = () => (
  <div className="flex h-screen items-center justify-center">
    <Spinner className="size-10" />
  </div>
);
